// extracted by mini-css-extract-plugin
export const notes = "item-notes-module--notes--Z8SlW";
export const closeButton = "item-notes-module--closeButton--Sr6hR";
export const footer = "item-notes-module--footer--3P1Un";